module.exports = __webpack_public_path__ + "static/media/pan-cubierta.1a30f840.png";